import React, {
    useEffect,
    useState,
    useCallback,
    useRef,
    memo
} from 'react';

import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";

import { api } from '../../services/api.js';

import Swal from 'sweetalert2';

import {
    ReactSketchCanvas
} from 'react-sketch-canvas';

import imageCompression from 'browser-image-compression';

const FotoItemPreview = memo(({
    foto,
    loading,
    onAmpliar
}) => {

    if (loading) {

        return (
            <div
                className="border rounded bg-light d-flex flex-column align-items-center justify-content-center"
                style={{
                    height: '160px'
                }}
            >

                <div className="spinner-border spinner-border-sm text-primary mb-2"></div>

                <small className="text-muted">
                    Carregando...
                </small>

            </div>
        );

    }

    if (!foto) {

        return (
            <div
                className="border rounded bg-light d-flex align-items-center justify-content-center text-muted"
                style={{
                    height: '160px'
                }}
            >
                Sem Foto
            </div>
        );

    }

    return (
        <img
            src={`data:image/jpeg;base64,${foto}`}
            alt=""
            loading="lazy"
            onClick={() =>
                onAmpliar(
                    `data:image/jpeg;base64,${foto}`
                )
            }
            className="img-fluid rounded border shadow-sm"
            style={{
                height: '160px',
                width: '100%',
                objectFit: 'cover',
                cursor: 'pointer'
            }}
        />
    );

});

FotoItemPreview.displayName = 'FotoItemPreview';

const VistoriaGestao = () => {

    const [loading, setLoading] = useState(false);
    const [loadingTexto, setLoadingTexto] = useState("Processando...");

    const [etapa, setEtapa] = useState('LISTA');

    const [vistorias, setVistorias] = useState([]);

    const [lojas, setLojas] = useState([]);

    const [lojaSelecionada, setLojaSelecionada] =
        useState("0");

    const [vistoriaAtual, setVistoriaAtual] =
        useState(null);

    const [prazoFinalizacao, setPrazoFinalizacao] =
        useState('');

    const [ponto, setPonto] = useState({
        descricao: '',
        tipo: 'TAREFA',
        foto: ''
    });

    const [itensNovaVistoria, setItensNovaVistoria] =
        useState([]);

    const [vistoriaEmAnalise, setVistoriaEmAnalise] =
        useState(null);

    const [itensAnalise, setItensAnalise] =
        useState([]);

    const [previewEdicao, setPreviewEdicao] =
        useState(null);

    const [imagemTempBase64, setImagemTempBase64] =
        useState(null);

    const [fotoAmpliada, setFotoAmpliada] =
        useState(null);

    const canvasRef = useRef(null);

    /*
        CACHE DAS FOTOS
        Evita:
        - recarregar ao ampliar
        - recarregar ao fechar
        - recarregar ao voltar análise
    */
    const fotosCacheRef = useRef({});

    const idLojaPadrao =
        localStorage.getItem("loja");

    const eSupervisor =
        localStorage.getItem("permiteRegional") === 'S' ||
        localStorage.getItem("diretor") === 'S';

    const carregarVistorias =
        useCallback(async (codEmp) => {

            try {
                /*
                    NÃO BLOQUEIA MAIS A TELA
                    enquanto busca vistorias
                */
                const res =
                    await api.get('/vistoria');

                const lista =
                    res.data || [];

                if (
                    codEmp !== "0" &&
                    codEmp !== 0
                ) {

                    const filtradas =
                        lista.filter(
                            x =>
                                String(
                                    x.id_loja ||
                                    x.ID_LOJA
                                ) === String(codEmp)
                        );

                    setVistorias(
                        filtradas
                    );

                } else {

                    setVistorias(
                        lista
                    );

                }

            } catch (err) {
                console.error(err);
            }

        }, []);

    useEffect(() => {

        api.get("lojas/localizacao")
            .then(res => {

                setLojas(
                    res.data || []
                );

                if (eSupervisor) {

                    carregarVistorias("0");

                } else {

                    setLojaSelecionada(
                        idLojaPadrao
                    );

                    carregarVistorias(
                        idLojaPadrao
                    );

                }

            });

    }, [idLojaPadrao, eSupervisor, carregarVistorias]);

    const criarOuContinuarVistoria =
        async () => {

            if (
                lojaSelecionada === "0" ||
                !lojaSelecionada
            ) {

                return Swal.fire(
                    'Atenção',
                    'Selecione uma loja.',
                    'warning'
                );

            }

            try {

                setLoadingTexto("Iniciando auditoria...");
                setLoading(true);

                const existente =
                    vistorias.find(
                        x =>
                            (
                                x.status === 'CRIANDO' ||
                                x.STATUS === 'CRIANDO'
                            ) &&
                            String(
                                x.id_loja ||
                                x.ID_LOJA
                            ) === String(lojaSelecionada)
                    );

                if (existente) {

                    await continuarInclusao(
                        existente
                    );

                    return;

                }

                const res =
                    await api.post(
                        '/vistoria',
                        {
                            id_loja:
                                lojaSelecionada,
                            id_supervisor:
                                localStorage.getItem("chapa")
                        }
                    );

                setVistoriaAtual({
                    id_vistoria:
                        res.data.id_vistoria,
                    id_loja:
                        lojaSelecionada,
                    status:
                        'CRIANDO'
                });

                setItensNovaVistoria([]);

                setEtapa('NOVO');

                await carregarVistorias(
                    lojaSelecionada
                );

            } catch (e) {

                console.error(e);

                Swal.fire(
                    'Erro',
                    'Falha ao iniciar vistoria.',
                    'error'
                );

            } finally {

                setLoading(false);

            }

        };

    const continuarInclusao =
        async (vistoria) => {

            try {

                setLoadingTexto("Carregando itens pendentes...");
                setLoading(true);

                const res =
                    await api.get(
                        `/vistoria/${vistoria.id_vistoria}/itens`
                    );

                setItensNovaVistoria(
                    res.data || []
                );

                setVistoriaAtual(
                    vistoria
                );

                setEtapa('NOVO');

            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        };

    /*
        LÓGICA EM SEGUNDO PLANO
        1 - abre instantaneamente
        2 - fotos carregam em background
        3 - cada foto possui loading próprio
        4 - cache evita reload
    */
    const abrirAnalise =
        async (v) => {

            try {

                setLoadingTexto("Buscando pontos da vistoria...");
                setLoading(true);

                const resItens =
                    await api.get(
                        `/vistoria/${v.id_vistoria}/itens`
                    );

                const itens =
                    (resItens.data || []).map(item => ({

                        ...item,

                        foto_antes:
                            fotosCacheRef.current[item.id_item]?.foto_antes || null,

                        foto_depois:
                            fotosCacheRef.current[item.id_item]?.foto_depois || null,

                        loadingFoto:
                            !fotosCacheRef.current[item.id_item]

                    }));

                setItensAnalise(itens);

                setVistoriaEmAnalise(v);

                setEtapa('ANALISE');

                setLoading(false);

                itens.forEach(async (item) => {

                    /*
                        SE JÁ ESTÁ EM CACHE
                        NÃO BUSCA NOVAMENTE
                    */
                    if (
                        fotosCacheRef.current[item.id_item]
                    ) {
                        return;
                    }

                    try {

                        const resFoto =
                            await api.get(
                                `/vistoria/foto/${item.id_item}`
                            );

                        const foto =
                            resFoto.data?.[0] || {};

                        const dadosFoto = {

                            foto_antes:
                                foto.foto_antes || null,

                            foto_depois:
                                foto.foto_depois || null

                        };

                        /*
                            SALVA EM CACHE
                        */
                        fotosCacheRef.current[item.id_item] =
                            dadosFoto;

                        /*
                            ATUALIZA SOMENTE ITEM ALTERADO
                        */
                        setItensAnalise(prev =>
                            prev.map(x => {

                                if (
                                    x.id_item !== item.id_item
                                ) {
                                    return x;
                                }

                                return {
                                    ...x,
                                    ...dadosFoto,
                                    loadingFoto: false
                                };

                            })
                        );

                    } catch (e) {

                        console.error(e);

                        setItensAnalise(prev =>
                            prev.map(x => {

                                if (
                                    x.id_item !== item.id_item
                                ) {
                                    return x;
                                }

                                return {
                                    ...x,
                                    loadingFoto: false
                                };

                            })
                        );

                    }

                });

            } catch (err) {

                console.error(err);
                setLoading(false);

                Swal.fire(
                    'Erro',
                    'Não foi possível carregar os detalhes.',
                    'error'
                );

            }

        };

    const consolidarParaDiretoria = async () => {
        if (!vistoriaEmAnalise) return;
        
        try {
            setLoadingTexto("O Gemini está compilando a síntese operacional e gravando no banco...");
            setLoading(true);
            
            await api.post(`/vistoria/enviar-relatorio/${vistoriaEmAnalise.id_vistoria}`);
            
            Swal.fire({
                title: 'Sucesso!',
                text: 'A síntese analítica foi estruturada e salva com status Pendente na fila de e-mails.',
                icon: 'success',
                confirmButtonColor: '#1a365d'
            });
        } catch (err) {
            console.error(err);
            Swal.fire('Erro', 'Falha ao processar e-mail de consolidação.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleFotoPonto =
        async (e) => {

            const file =
                e.target.files[0];

            if (!file) return;

            try {

                setLoadingTexto("Otimizando tamanho do arquivo...");
                setLoading(true);

                const compressedFile =
                    await imageCompression(
                        file,
                        {
                            maxSizeMB: 0.4,
                            maxWidthOrHeight: 1600,
                            useWebWorker: true
                        }
                    );

                const reader =
                    new FileReader();

                reader.onload = () => {

                    setImagemTempBase64(
                        reader.result
                    );

                    setPreviewEdicao(
                        reader.result
                    );

                };

                reader.readAsDataURL(
                    compressedFile
                );

            } catch (err) {

                console.error(err);

                Swal.fire(
                    'Erro',
                    'Falha ao processar imagem.',
                    'error'
                );

            } finally {

                setLoading(false);

            }

        };

    const salvarEdicaoFoto =
        async () => {

            try {

                setLoadingTexto("Renderizando canvas gráfico...");
                setLoading(true);

                const paths =
                    await canvasRef.current.exportPaths();

                if (
                    !paths ||
                    paths.length === 0
                ) {

                    setPonto(prev => ({
                        ...prev,
                        foto:
                            imagemTempBase64
                                .split(',')[1]
                    }));

                    setPreviewEdicao(null);

                    setLoading(false);

                    return;

                }

                const canvas =
                    document.createElement('canvas');

                const ctx =
                    canvas.getContext('2d');

                const img =
                    new Image();

                img.src =
                    imagemTempBase64;

                img.onload =
                    async () => {

                        canvas.width =
                            img.width;

                        canvas.height =
                            img.height;

                        ctx.drawImage(
                            img,
                            0,
                            0
                        );

                        paths.forEach(path => {

                            ctx.beginPath();

                            ctx.strokeStyle =
                                path.strokeColor ||
                                'red';

                            ctx.lineWidth =
                                path.strokeWidth || 5;

                            path.paths.forEach(
                                (p, index) => {

                                    if (index === 0) {

                                        ctx.moveTo(
                                            p.x,
                                            p.y
                                        );

                                    } else {

                                        ctx.lineTo(
                                            p.x,
                                            p.y
                                        );

                                    }

                                }
                            );

                            ctx.stroke();

                        });

                        const finalBase64 =
                            canvas.toDataURL(
                                'image/jpeg',
                                0.8
                            );

                        setPonto(prev => ({
                            ...prev,
                            foto:
                                finalBase64
                                    .split(',')[1]
                        }));

                        setPreviewEdicao(null);

                        setLoading(false);

                    };

            } catch (e) {

                console.error(e);
                setLoading(false);

                Swal.fire(
                    'Erro',
                    'Falha ao salvar edição.',
                    'error'
                );

            }

        };

    const adicionarItem =
        async () => {

            if (!ponto.descricao) {

                return Swal.fire(
                    'Atenção',
                    'Informe a descrição.',
                    'warning'
                );

            }

            if (
                ponto.tipo === 'TAREFA' &&
                !ponto.foto
            ) {

                return Swal.fire(
                    'Atenção',
                    'GERAR TAREFA exige foto.',
                    'warning'
                );

            }

            try {

                setLoadingTexto("Salvando apontamento no banco...");
                setLoading(true);

                await api.post(
                    '/vistoria/item',
                    {
                        id_vistoria:
                            vistoriaAtual.id_vistoria,
                        descricao:
                            ponto.descricao,
                        tipo:
                            ponto.tipo,
                        foto:
                            ponto.foto
                    }
                );

                const res =
                    await api.get(
                        `/vistoria/${vistoriaAtual.id_vistoria}/itens`
                    );

                setItensNovaVistoria(
                    res.data || []
                );

                setPonto({
                    descricao: '',
                    tipo: 'TAREFA',
                    foto: ''
                });

                document.getElementById(
                    'foto-input'
                ).value = '';

                Swal.fire({
                    toast: true,
                    position: 'top',
                    timer: 1500,
                    icon: 'success',
                    showConfirmButton: false,
                    title: 'Item incluído'
                });

            } catch (e) {

                console.error(e);

                Swal.fire(
                    'Erro',
                    'Falha ao incluir item.',
                    'error'
                );

            } finally {

                setLoading(false);

            }

        };

    const finalizarVistoria =
        async () => {

            if (!prazoFinalizacao) {

                return Swal.fire(
                    'Atenção',
                    'Informe o prazo final.',
                    'warning'
                );

            }

            try {

                setLoadingTexto("Fechando cabeçalho de vistoria...");
                setLoading(true);

                await api.put(
                    `/vistoria/finalizar/${vistoriaAtual.id_vistoria}`,
                    {
                        prazo:
                            prazoFinalizacao
                    }
                );

                Swal.fire(
                    'Sucesso',
                    'Vistoria finalizada.',
                    'success'
                );

                setPrazoFinalizacao('');

                setItensNovaVistoria([]);

                setVistoriaAtual(null);

                setEtapa('LISTA');

                carregarVistorias(
                    lojaSelecionada
                );

            } catch (e) {

                console.error(e);

                Swal.fire(
                    'Erro',
                    'Falha ao finalizar.',
                    'error'
                );

            } finally {

                setLoading(false);

            }

        };

    const compartilharWhatsApp = (v) => {

        const tokenValido =
            v.link_token || v.LINK_TOKEN;

        const baseUrl =
            window.location.origin;

        const link =
            `${baseUrl}/arbor/Loja/vistoria-execucao/${tokenValido}`;

        const msg =
            `*ARBOR - AUDITORIA INTERNA*\n` +
            `📍 *Filial:* ${v.razao}\n\n` +
            `Prezado(a) Gerente, mapeamos inconformidades na sua loja. Acesse o link abaixo para visualizar os registros fotográficos e anexar as correções efetuadas:\n\n` +
            `🔗 ${link}`;

        window.open(
            `https://wa.me/?text=${encodeURIComponent(msg)}`,
            '_blank'
        );

    };

    return (
        <>
            <Menu modulo="ARBOR" />

            {/* TELA DE AGUARDE UNIFICADA */}
            {loading && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 43, 91, 0.85)',
                    zIndex: 99999, display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', padding: '20px'
                }}>
                    <div className="spinner-border text-light mb-3" style={{ width: '3.5rem', height: '3.5rem' }}></div>
                    <h6 className="text-white text-center fw-bold">{loadingTexto}</h6>
                </div>
            )}

            <div className="container mt-4" style={{ paddingTop: '75px', marginBottom: '100px' }}>

                {etapa === 'LISTA' && (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-2" >
                            <h5 className="fw-bold text-primary m-0">
                                Gestão de Vistorias
                            </h5>
                            {eSupervisor && (
                                <button
                                    className="btn btn-primary rounded-pill px-4"
                                    onClick={criarOuContinuarVistoria}
                                >
                                    + Nova
                                </button>
                            )}
                        </div>

                        <div className="card border-0 shadow-sm p-2 mb-2" >
                            <select
                                className="form-select border-0 bg-light"
                                value={lojaSelecionada}
                                onChange={(e) => {
                                    setLojaSelecionada(
                                        e.target.value
                                    );
                                    carregarVistorias(
                                        e.target.value
                                    );
                                }}
                            >
                                {eSupervisor && (
                                    <option value="0">
                                        TODAS AS LOJAS
                                    </option>
                                )}
                                {lojas.map(l => (
                                    <option
                                        key={l.cod_emp}
                                        value={l.cod_emp}
                                    >
                                        {l.cod_emp} - {l.razao}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="row g-2">
                            {vistorias.map(v => {
                                const status =
                                    v.status || v.STATUS;
                                return (
                                    <div
                                        className="col-12 col-md-4"
                                        key={v.id_vistoria}
                                    >
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body p-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="badge bg-dark">
                                                        #{v.id_vistoria}
                                                    </span>
                                                    <span
                                                        className={`badge ${
                                                            status === 'CRIANDO'
                                                                ? 'bg-warning text-dark'
                                                                : status === 'FINALIZADA'
                                                                ? 'bg-success'
                                                                : 'bg-danger'
                                                        }`}
                                                    >
                                                        {status}
                                                    </span>
                                                </div>
                                                <div className="fw-bold">
                                                    Loja {v.id_loja}
                                                </div>
                                                <div className="small text-muted mb-2">
                                                    {v.razao}
                                                </div>
                                                <div className="small text-danger mb-3">
                                                    Prazo: {v.prazo || v.prazo_execucao || '-'}
                                                </div>
                                                <div className="small text-muted mb-2">
                                                    <strong>Criador: </strong>{v.nome || '-'}
                                                </div>
                                                <div className="d-flex gap-2">
                                                    {status === 'CRIANDO' ? (
                                                        <button
                                                            className="btn btn-warning btn-sm w-100"
                                                            onClick={() =>
                                                                continuarInclusao(v)
                                                            }
                                                        >
                                                            Continuar Incluindo
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button
                                                                className="btn btn-success btn-sm w-100"
                                                                onClick={() =>
                                                                    compartilharWhatsApp(v)
                                                                }
                                                            >
                                                                WhatsApp
                                                            </button>
                                                            <button
                                                                className="btn btn-light btn-sm w-100"
                                                                onClick={() =>
                                                                    abrirAnalise(v)
                                                                }
                                                            >
                                                                Analisar
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {etapa === 'NOVO' && (
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="fw-bold mb-1">
                                        Vistoria #{vistoriaAtual?.id_vistoria}
                                    </h5>
                                    <small className="text-muted">
                                        Inclusão de itens
                                    </small>
                                </div>
                                <span className="badge bg-warning text-dark">
                                    CRIANDO
                                </span>
                            </div>

                            <div className="mb-3">
                                <label className="small fw-bold">
                                    Descrição
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={ponto.descricao}
                                    onChange={(e) =>
                                        setPonto({
                                            ...ponto,
                                            descricao:
                                                e.target.value
                                        })
                                    }
                                />
                            </div>

                            <div className="row g-2 mb-3">
                                <div className="col-12 col-md-6">
                                    <label className="small fw-bold">
                                        Tipo
                                    </label>
                                    <select
                                        className="form-select"
                                        value={ponto.tipo}
                                        onChange={(e) =>
                                            setPonto({
                                                ...ponto,
                                                tipo:
                                                    e.target.value
                                            })
                                        }
                                    >
                                        <option value="TAREFA">
                                            GERAR TAREFA
                                        </option>
                                        <option value="OBSERVACAO">
                                            APENAS OBSERVAÇÃO
                                        </option>
                                        <option value="ELOGIO">
                                            ELOGIO
                                        </option>
                                    </select>
                                </div>

                                <div className="col-12 col-md-6">
                                    <label className="small fw-bold d-block">
                                        Foto
                                    </label>
                                    <label
                                        className="btn btn-primary w-100"
                                    >
                                        FOTO
                                        <input
                                            id="foto-input"
                                            type="file"
                                            capture="environment"
                                            accept="image/*"
                                            hidden
                                            onChange={handleFotoPonto}
                                        />
                                    </label>
                                </div>
                            </div>

                            {ponto.foto && (
                                <div className="mb-3">
                                    <img
                                        src={`data:image/jpeg;base64,${ponto.foto}`}
                                        alt=""
                                        onClick={() =>
                                            setFotoAmpliada(
                                                `data:image/jpeg;base64,${ponto.foto}`
                                            )
                                        }
                                        className="img-fluid rounded border shadow-sm"
                                        style={{
                                            maxHeight: '220px',
                                            width: '100%',
                                            objectFit: 'cover',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </div>
                            )}

                            <button
                                className="btn btn-info w-100 text-white fw-bold mb-3"
                                onClick={adicionarItem}
                            >
                                + Incluir Item
                            </button>

                            <div
                                style={{
                                    maxHeight: '260px',
                                    overflowY: 'auto'
                                }}
                            >
                                {itensNovaVistoria.map((it, idx) => (
                                    <div
                                        key={idx}
                                        className="border rounded p-2 bg-light mb-2"
                                    >
                                        <div className="fw-bold small">
                                            {it.tipo}
                                        </div>
                                        <div className="small">
                                            {it.descricao_ponto || it.descricao}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-3">
                                <label className="small fw-bold">
                                    Prazo Final
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={prazoFinalizacao}
                                    min={
                                        new Date()
                                            .toISOString()
                                            .split('T')[0]
                                    }
                                    onChange={(e) =>
                                        setPrazoFinalizacao(
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                        </div>

                        <div
                            className="card-footer bg-white border-0"
                            style={{
                                position: 'sticky',
                                bottom: 0
                            }}
                        >
                            <div className="d-flex gap-2">
                                <button
                                    className="btn btn-outline-secondary w-50"
                                    onClick={() =>
                                        setEtapa('LISTA')
                                    }
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-success w-50 fw-bold"
                                    onClick={finalizarVistoria}
                                >
                                    Finalizar Tudo
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {etapa === 'ANALISE' && vistoriaEmAnalise && (
                    <div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-light rounded-circle me-2"
                                    onClick={() =>
                                        setEtapa('LISTA')
                                    }
                                >
                                    <i className="fa fa-arrow-left"></i>
                                </button>
                                <h5 className="fw-bold m-0">
                                    Vistoria #{vistoriaEmAnalise.id_vistoria}
                                </h5>
                            </div>
                            
                            {/*eSupervisor && (
                                <button 
                                    className="btn btn-sm btn-dark rounded-pill px-3 py-2 fw-bold shadow-sm" 
                                    onClick={consolidarParaDiretoria}
                                >
                                    <i className="fa fa-envelope-open-text me-1 text-warning"></i> Notificar Diretoria (IA)
                                </button>
                            )*/}
                        </div>

                        <div className="row g-2">
                            {itensAnalise.map(item => (
                                <div
                                    className="col-12"
                                    key={item.id_item}
                                >
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="badge bg-light text-dark border small">{item.tipo}</span>
                                                <span
                                                    className={`small fw-bold ${
                                                        item.status_item === 'EXECUTADO'
                                                            ? 'text-success'
                                                            : 'text-warning'
                                                    }`}
                                                >
                                                    {item.status_item === 'EXECUTADO'
                                                        ? '● CONCLUÍDO'
                                                        : '○ PENDENTE'}
                                                </span>
                                            </div>
                                            <div className="fw-bold text-danger small mb-1">
                                                {item.tipo}
                                            </div>
                                            <div className="mb-3">
                                                {item.descricao_ponto}
                                            </div>

                                            {/* GRID PARALELO LADO A LADO */}
                                            <div className="row g-2">
                                                <div className="col-6 text-center">
                                                    <span className="small d-block text-muted mb-1">Antes</span>
                                                    <FotoItemPreview
                                                        foto={item.foto_antes}
                                                        loading={item.loadingFoto}
                                                        onAmpliar={setFotoAmpliada}
                                                    />
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="small d-block text-muted mb-1">Depois</span>
                                                    <FotoItemPreview
                                                        foto={item.foto_depois}
                                                        loading={item.loadingFoto}
                                                        onAmpliar={setFotoAmpliada}
                                                    />
                                                </div>
                                            </div>

                                            {item.obs_gerente && (
                                                <div className="mt-2 p-2 bg-light border-start border-4 border-success small">
                                                    <strong>Solução do Gerente:</strong> {item.obs_gerente}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>

            {/* CANVAS DE DESENHO EM TELA CHEIA */}
            {previewEdicao && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: '#fff',
                        zIndex: 999999,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <div className="p-3 bg-dark text-white d-flex justify-content-between align-items-center">
                        <span className="fw-bold">
                            Marcar inconformidade na Imagem
                        </span>
                        <button
                            className="btn btn-success btn-sm fw-bold px-3"
                            onClick={salvarEdicaoFoto}
                        >
                            Confirmar
                        </button>
                    </div>

                    <div
                        style={{
                            flex: 1,
                            position: 'relative',
                            background: '#111'
                        }}
                    >
                        <ReactSketchCanvas
                            ref={canvasRef}
                            strokeWidth={6}
                            strokeColor="red"
                            backgroundImage={previewEdicao}
                            preserveBackgroundImageAspectRatio="xMidYMid meet"
                            style={{
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    </div>

                    <div className="p-3 d-flex gap-2 bg-light">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() =>
                                setPreviewEdicao(null)
                            }
                        >
                            Voltar sem Marcar
                        </button>

                        <button
                            className="btn btn-danger w-100"
                            onClick={() =>
                                canvasRef.current.clearCanvas()
                            }
                        >
                            Limpar
                        </button>
                    </div>
                </div>
            )}

            {/* MODAL LIGHTBOX */}
            {fotoAmpliada && (
                <div
                    onClick={() =>
                        setFotoAmpliada(null)
                    }
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.95)',
                        zIndex: 99999999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '10px'
                    }}
                >
                    <img
                        src={fotoAmpliada}
                        alt=""
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            )}

            <Footer />
        </>
    );
};

export default VistoriaGestao;